module.exports = __webpack_public_path__ + "static/media/select.82526358.svg";